import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleQuote32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconSpeechBubbleQuote32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11 23v-2H7a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-8.69l-.543.425L11 25.156zm14 0h-8l-6.384 4.996A1 1 0 0 1 9 27.208V23H7a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h18a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4M14.435 12.4a1 1 0 0 0-.867-1.802L14 11.5c-.432-.902-.433-.901-.433-.901h-.001l-.003.002-.006.003-.02.01a5 5 0 0 0-.262.14 7 7 0 0 0-.626.41c-.446.33-1.09.898-1.385 1.685-.255.678-.305 1.445-.308 1.98a9 9 0 0 0 .048.966l.002.018.001.006v.003h.005-.005q.008.06.021.114a2 2 0 1 0 2.09-2.332l.018-.053c.088-.233.344-.514.702-.78a4.5 4.5 0 0 1 .562-.353l.03-.015zm6 0a1 1 0 0 0-.867-1.802L20 11.5c-.432-.902-.433-.901-.433-.901h-.001l-.003.002-.006.003-.02.01a5 5 0 0 0-.262.14 7 7 0 0 0-.626.41c-.446.33-1.09.898-1.385 1.685-.255.678-.305 1.445-.308 1.98a9 9 0 0 0 .048.966l.002.018.001.006v.003h.005l-.005.001q.008.057.021.113a2 2 0 1 0 2.09-2.332l.018-.053c.088-.233.344-.514.702-.78a4.5 4.5 0 0 1 .562-.353l.02-.01.01-.005z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleQuote32);
